import { __ } from '@wordpress/i18n';
import { useBlockProps, InspectorControls, MediaUpload, MediaUploadCheck } from '@wordpress/block-editor';
import { PanelBody, SelectControl, RangeControl, Button, TextControl, ToggleControl } from '@wordpress/components';

import './editor.scss';


export default function Edit( { attributes, setAttributes } ) {
	const { logos, template, animationDuration, showAltText, logoSize, slideDirection } = attributes;
	const blockProps = useBlockProps();

	const addLogo = ( media ) => {
		const newLogos = [
			...logos,
			{
				id: media.id,
				url: media.url,
				alt: media.alt || '',
				link: '',
			},
		];
		setAttributes( { logos: newLogos } );
	};

	const updateLogo = ( index, field, value ) => {
		const newLogos = [ ...logos ];
		newLogos[ index ][ field ] = value;
		setAttributes( { logos: newLogos } );
	};

	const removeLogo = ( index ) => {
		const newLogos = logos.filter( ( _, i ) => i !== index );
		setAttributes( { logos: newLogos } );
	};

	return (
		<>
			<InspectorControls>
				<PanelBody title={ __( 'Carousel Settings', 'wbd-logo-carousel' ) }>
					<SelectControl
						label={ __( 'Template Style', 'wbd-logo-carousel' ) }
						value={ template }
						options={ [
							{ label: __( 'Classic', 'wbd-logo-carousel' ), value: 'classic' },
							{ label: __( 'Elegant', 'wbd-logo-carousel' ), value: 'elegant' },
						] }
						onChange={ ( value ) => setAttributes( { template: value } ) }
					/>
					<SelectControl
						label={ __( 'Slide Direction', 'logo-carousel' ) }
						value={ slideDirection }
						options={ [
							{ label: __( 'Left', 'wbd-logo-carousel' ), value: 'left' },
							{ label: __( 'Right', 'wbd-logo-carousel' ), value: 'right' },
						] }
						onChange={ ( value ) => setAttributes( { slideDirection: value } ) }
					/>
					<RangeControl
						label={ __( 'Animation Duration (seconds)', 'wbd-logo-carousel' ) }
						value={ animationDuration }
						onChange={ ( value ) => setAttributes( { animationDuration: value } ) }
						min={ 10 }
						max={ 60 }
						step={ 5 }
					/>
					<RangeControl
						label={ __( 'Logo Size (px)', 'wbd-logo-carousel' ) }
						value={ logoSize }
						onChange={ ( value ) => setAttributes( { logoSize: value } ) }
						min={ 50 }
						max={ 300 }
						step={ 10 }
					/>
					<ToggleControl
						label={ __( 'Show Alt Text', 'wbd-logo-carousel' ) }
						checked={ showAltText }
						onChange={ ( value ) => setAttributes( { showAltText: value } ) }
					/>
				</PanelBody>
			</InspectorControls>

			<div { ...blockProps }>
				<div className={ `logo-carousel logo-carousel--${ template }` }>
					<div className="logo-carousel__header">
						<h3>{ __( 'Logo Carousel', 'wbd-logo-carousel' ) }</h3>
						<p className="logo-carousel__template-label">
							{ __( 'Template:', 'wbd-logo-carousel' ) } <strong>{ template.charAt( 0 ).toUpperCase() + template.slice( 1 ) }</strong>
							{ ' | ' }
							{ __( 'Direction:', 'wbd-logo-carousel' ) } <strong>{ slideDirection.charAt( 0 ).toUpperCase() + slideDirection.slice( 1 ) }</strong>
						</p>
					</div>

					<div className="logo-carousel__logos">
						{ logos.map( ( logo, index ) => (
							<div key={ logo.id } className="logo-carousel__logo-item">
								<img 
									src={ logo.url } 
									alt={ logo.alt } 
									style={{ maxWidth: `${logoSize}px` }}
								/>
								{ showAltText && logo.alt && (
									<p className="logo-carousel__alt-text">{ logo.alt }</p>
								) }
								<div className="logo-carousel__logo-controls">
									<TextControl
										label={ __( 'Link URL', 'wbd-logo-carousel' ) }
										value={ logo.link }
										onChange={ ( value ) => updateLogo( index, 'link', value ) }
										placeholder="https://"
									/>
									<TextControl
										label={ __( 'Alt Text', 'wbd-logo-carousel' ) }
										value={ logo.alt }
										onChange={ ( value ) => updateLogo( index, 'alt', value ) }
									/>
									<Button
										isDestructive
										onClick={ () => removeLogo( index ) }
									>
										{ __( 'Remove', 'wbd-logo-carousel' ) }
									</Button>
								</div>
							</div>
						) ) }
					</div>

					<MediaUploadCheck>
						<MediaUpload
							onSelect={ addLogo }
							allowedTypes={ [ 'image' ] }
							value={ logos.map( ( l ) => l.id ) }
							render={ ( { open } ) => (
								<Button
									onClick={ open }
									variant="primary"
									className="logo-carousel__add-button"
								>
									{ __( '+ Add Logo', 'logo-carousel' ) }
								</Button>
							) }
						/>
					</MediaUploadCheck>
				</div>
			</div>
		</>
	);
}
